module.exports = __webpack_public_path__ + "media/images/platforms/mobile/square-b135094c980f7f531096bef4c2bf1a8b.jpg";